import React from 'react';
import Modal from 'simple-react-modal';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import qs from 'qs';

import callApi from '../../utils/callApi';
import { buildAnchorLink, capitalize, getCookie } from '../../utils/helpers';
import {
  BASE_URL,
  CLIPSTORE_GALLERY_PAY_INFO,
  CLIPSTORE_VIDEO_PAY_INFO,
  FETCH_GENERATED_USERNAME,
  STATUS_URL,
} from '../../constants/apiUrls/apiUrls';
import { PROCESSOR_IDS } from '../../constants/processors';
import { EXPIRED_PROMOS, PROMO_CODES } from '../../constants/promoCodes';
import PayPerViewStore from '../../store/PayPerViewStore';
import PaysafeForm from '../../components/paymentComponents/PaysafeForm';

import ClipStoreItemPurchaseContent from './ClipStorePurchaseItemContent';


import './AccountPackages.css';
import TippingModalContent from './TippingModalContent';
import FanzoneSubscriptionForm from './FanzoneSubscriptionForm';
import MembershipForm from './MembershipForm';
import { getFanclubPurchaseInfo, getPurchaseInfo } from './services';

import {
  addDataForGiftAndItemProduct,
  decidePromoInfo,
  generateSiteSubcat,
  getPaymentProcessor,
  getPurchaseError,
  redirectToProcessor,
} from '../paymentComponents/PaymentUtils';
import NotificationStore from '../../store/NotificationStore';
import PaymentStore from '../../store/PaymentStore';


const REDIRECT_COUNTER_VALUE = 3000;
const NAKED_NEWS_LIVE_ID = 241;

@observer
class AccountPackages extends React.Component {
  static propTypes = {
    NNLivePromoPage: PropTypes.bool,
    NNPromoPage: PropTypes.bool,
    activeCampaign: PropTypes.object,
    amountParam: PropTypes.object,
    anchorName: PropTypes.string,
    anchorPortalCampaign: PropTypes.object,
    anchorShortUrl: PropTypes.string,
    anchorSubscriptionPrograms: PropTypes.object,
    anchorToSubscribe: PropTypes.string,
    clipId: PropTypes.number,
    closeModal: PropTypes.func,
    closeTipping: PropTypes.func,
    createdUser: PropTypes.string,
    disableOneClickPaysafe: PropTypes.bool,
    isGift: PropTypes.bool,
    isInvisible: PropTypes.bool,
    isItem: PropTypes.bool,
    listOfActiveCampaigns: PropTypes.array,
    price: PropTypes.number,
    programs: PropTypes.array,
    returnPath: PropTypes.string,
    startPurchaseTimer: PropTypes.func,
    title: PropTypes.string,
    token: PropTypes.string,
    type: PropTypes.string,
    user: PropTypes.object,
  };

  constructor(props) {
    super(props);
    let activeProgram = null;

    if (props.anchorToSubscribe && !props.isGift && !props.isItem) {
      activeProgram = props.anchorSubscriptionPrograms[0];
    } else if (props.disableOneClickPaysafe && props.amountParam) {
      activeProgram = props.programs.find(
        (program) => program.amount === props.amountParam
      );
    } else if (props.isGift || props.isItem) {
      activeProgram = props.programs[0];
    } else {
      activeProgram =
        props.programs.find((program) => program.details.default) ||
        props.programs[0];
    }

    const getOneClickPaymentData = () => activeProgram.categories.find((category) => category.methods[0].hasOneClick);
    this.queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });

    this.state = {
      submitButtonDisabled: false,
      username: [],
      activeProgram,
      redirectCounter: REDIRECT_COUNTER_VALUE,
      showPaysafeModal: false,
      holderName: '',
      country: '',
      zip: '',
      email: '',
      errors: [],
      processingPayment: false,
      purchaseId: null,
      disablePurchaseButton: false,
      selectedPaymentMethod: props.disableOneClickPaysafe ? 'CC' : activeProgram?.categories[0]?.type,
      paysafeAvailable: activeProgram.categories.find(
        (category) => category.type === 'CC'
      ),
      epochAvailable: activeProgram.categories.find(
        (category) => category.type === 'EW'
      ),
      showOverlay: true,
      oneClickPaymentData: this.props.disableOneClickPaysafe ? null : getOneClickPaymentData(),
      promoCodeInfo: {
        affiliateCode: null,
      },
      shouldAnimate: false,
      availableProcessors: activeProgram?.categories[0]?.methods,
      oldPrices: this.props?.programs || this.props?.anchorSubscriptionPrograms,
    };
  }

  componentDidMount() {
    const { activeProgram } = this.state;
    const { anchorPortalCampaign } = this.props;
    const paysafeAvailable = activeProgram.categories.find(
      (category) => category.type === 'CC'
    );
    const epochAvailable = activeProgram.categories.find(
      (category) => category.type === 'EW'
    );
    const affiliateCode = getCookie('_atc');
    const isAnchorCampaign =
      activeProgram &&
      anchorPortalCampaign &&
      anchorPortalCampaign.anchorPortal &&
      (affiliateCode === PROMO_CODES.CAM4_ANCHOR_SOURCE ||
        affiliateCode === PROMO_CODES.PROMO_ANCHOR_SOURCE) &&
      epochAvailable;

    if (this.props.disableOneClickPaysafe) {
      this.openPaysafeModal();
    }

    if (
      activeProgram &&
      affiliateCode === PROMO_CODES.CAM4_SOURCE &&
      epochAvailable
    ) {
      this.setState({ selectedPaymentMethod: 'EW' }, () => {
        this.onSubmitClick();
      });
    }

    if (isAnchorCampaign) {
      this.setState({ selectedPaymentMethod: 'EW' }, () => {
        this.onSubmitClick();
      });
    }

    if (
      !isAnchorCampaign &&
      (this.props.anchorSubscriptionPrograms ||
        !(affiliateCode === PROMO_CODES.CAM4_SOURCE))
    ) {
      this.setState({ showOverlay: false });
    }

    if (!epochAvailable || !paysafeAvailable) {
      let selectedPaymentMethod = null;
      if (!epochAvailable) {
        selectedPaymentMethod = 'CC';
      } else if (!paysafeAvailable) {
        selectedPaymentMethod = 'EW';
      }
      this.setState({ selectedPaymentMethod });
    }
  }

  getProducts = () => {
    const { programs, anchorSubscriptionPrograms, anchorToSubscribe, isGift, isItem } = this.props;
    if (anchorToSubscribe && !isGift && !isItem) {
      return anchorSubscriptionPrograms;
    }

    return programs;
  };

  checkForChangesInProgramsAndUpdate = (previousPrograms, programs) => {
    if (!programs?.length) {
      return;
    }

    const [firstPrevProgram, secondPrevProgram] = previousPrograms || [];
    const [firstProgram, secondProgram] = programs || [];
    const isSameFirst = firstPrevProgram?.id === firstProgram?.id;
    const isSameSecond = secondPrevProgram?.id === secondProgram?.id;
    if (!isSameFirst || !isSameSecond) {
      this.setState({
        activeProgram: firstProgram,
        shouldAnimate: true,
        oldPrices: previousPrograms,
      });
    }
  };

  componentDidUpdate(prevProps) {
    const { programs, anchorSubscriptionPrograms } = this.props;
    this.checkForChangesInProgramsAndUpdate(prevProps.programs, programs);
    this.checkForChangesInProgramsAndUpdate(prevProps.anchorSubscriptionPrograms, anchorSubscriptionPrograms);
  }

  setAnimationState = (booleanValue) => {
    this.setState({ shouldAnimate: booleanValue });
  };

  setPromoCodeInfo = (affiliateCode) => {
    this.setState({
      promoCodeInfo: {
        affiliateCode,
      },
    });
  };

  openPaysafeModal = () => {
    this.setState({ showPaysafeModal: true });
  };

  closePaysafeModal = () => {
    this.setState({ showPaysafeModal: false });
    if (this.props.isGift) {
      this.props.closeTipping();
    }
  };

  setPurchaseButtonDisabled = (value) => {
    this.setState({ disablePurchaseButton: value });
  };

  handlePackageChange = (e) => {
    const {
      programs,
      anchorSubscriptionPrograms,
      anchorToSubscribe,
      isGift,
    } = this.props;
    const targetProgram =
      anchorToSubscribe && !isGift ? anchorSubscriptionPrograms.find(
        (program) => program.id === parseInt(e.target.value, 10)
      ) : programs.find((program) => program.id === parseInt(e.target.value, 10));
    const paysafeAvailable = targetProgram?.categories.find(
      (category) => category.type === 'CC'
    );
    const epochAvailable = targetProgram?.categories.find(
      (category) => category.type === 'EW'
    );

    this.setState({
      activeProgram: targetProgram,
      paysafeAvailable,
      epochAvailable,
    });

    if (!epochAvailable || !paysafeAvailable) {
      let selectedPaymentMethod = null;
      if (!epochAvailable) {
        selectedPaymentMethod = 'CC';
      } else if (!paysafeAvailable) {
        selectedPaymentMethod = 'EW';
      }
      this.setState({ selectedPaymentMethod });
    }
  };

  sendToProcessor = (data) => {
    const { oneClickPaymentData } = this.state;
    const { startPurchaseTimer } = this.props;

    if (oneClickPaymentData && data?.nextStage?.parameters?.processorId === 27 && data?.nextStage?.parameters?.useFallback) {
      this.setState({ oneClickPaymentData: null }, this.openPaysafeModal);
    } else if (oneClickPaymentData && data.status === 'SUCCESS' && data?.nextStage?.parameters?.productType1 === 'GIFT') {
      this.props.closeTipping();
      this.props.setTipIsLoading(false);
      PayPerViewStore.setPaymentLoading(false);
      NotificationStore.success('Your tip was sent successfully!');
    } else if (
      data.status === 'SUCCESS' &&
      data?.nextStage?.parameters?.api === 'dynamicOneClick' &&
      data?.nextStage?.parameters?.productType1 === 'ITEM'
    ) {
      startPurchaseTimer();
      PayPerViewStore.setShowPayPerViewModal(false);
      PayPerViewStore.setStatusMessage('');
    } else {
      redirectToProcessor(data.nextStage.url, data?.nextStage?.parameters, this.props?.closeTipping, this.props?.closeModal);
    }
  };

  fetchUserName = () => callApi(
    FETCH_GENERATED_USERNAME,
    'post',
    {},
    {},
    { 'content-type': 'application/json; charset=utf-8' },
    false
  );

  getPaymentType = () => {
    const { selectedPaymentMethod } = this.state;

    return selectedPaymentMethod === 'CC' ? 'CC' : 'PP';
  };

  getReturnPath = () => {
    const { isGift, isItem } = this.props;
    if (!isGift && !isItem) {
      return '/checkout';
    }

    return window.location.pathname;
  };

  decideOriginalDomain = () => {
    const IS_DEV_ENV = window.location.hostname.includes('nakednews.galati.smart-x.dev') ||
    window.location.hostname.includes('local');
    if (BASE_URL && IS_DEV_ENV) {
      return BASE_URL;
    }

    return new URL(document.URL).origin;
  };

  getPriceId = (program) => {
    const { isItem, isGift } = this.props;
    if (isItem || isGift) {
      return program.id;
    }

    return program.priceId || program.id;
  }

  handlePurchaseForm = (program, processorId, token, xSellsState) => {
    const {
      user,
      anchorToSubscribe,
      anchorShortUrl,
      anchorPortalCampaign,
      isGift,
    } = this.props;
    const {
      holderName,
      email,
      oneClickPaymentData,
      purchaseId,
    } = this.state;
    const originalDomain = this.decideOriginalDomain();
    const priceId = this.getPriceId(program);
    const billingAddress = this.getBillingAddress();
    // const threeDS = this.getThreeDS();
    const affiliateCode = getCookie('_atc');
    const isAnchorCampaign =
      anchorPortalCampaign &&
      anchorPortalCampaign.anchorPortal &&
      (affiliateCode === PROMO_CODES.CAM4_ANCHOR_SOURCE ||
        affiliateCode === PROMO_CODES.PROMO_ANCHOR_SOURCE);
    PayPerViewStore.setPaymentLoading(true);

    let processorData = {};
    if (processorId === PROCESSOR_IDS.PAYSAFE) {
      processorData = {
        paymentType: 'CC',
        purchaseId,
        originalDomain,
        returnPath: this.getReturnPath(),
      };
      if (!oneClickPaymentData) {
        processorData = {
          ...processorData,
          paymentToken: token,
          holderName,
          email,
          billingAddress,
        };
      }
      if (
        xSellsState !== null &&
        typeof xSellsState === 'object' &&
        Object.keys(xSellsState).length > 0
      ) {
        const xSellPriceIds = [];
        Object.keys(xSellsState).forEach((xSellId) => {
          if (xSellsState[xSellId]) {
            xSellPriceIds.push(parseInt(xSellId, 10));
          }
        });
        processorData.xSellPriceIds = xSellPriceIds;
      }
    } else {
      processorData = {
        originalDomain,
        returnPath: this.getReturnPath(),
        paymentType: this.getPaymentType(),
      };
    }

    const promoPage = this.isPromoPage();
    if (
      (promoPage && affiliateCode && !EXPIRED_PROMOS.includes(affiliateCode)) ||
      user.features.includes(affiliateCode)
    ) {
      processorData.affiliateCode = affiliateCode;
    }

    if (anchorToSubscribe) {
      processorData.productType = isGift ? 'GIFT' : 'FANCLUB';
      processorData.subCategory = anchorToSubscribe;
    }

    this.setState({ processingPayment: true });
    let data = {};
    if (user.authenticated) {
      const username = user.user.username || this.props.createdUser;
      const newToken =
        sessionStorage.getItem('token') || user.user.token || this.props.token;
      const { xSellPriceIds, ...renewalData } = processorData;
      data = {
        username,
        token: newToken,
        ...renewalData,
      };

      if (anchorShortUrl || processorData.productType === 'MEMBERSHIP') {
        data.siteSubcat = generateSiteSubcat(
          data.originalDomain,
          anchorShortUrl
        );
      }
      this.processPurchaseRequest(processorId, priceId, username, data);
    } else if (this.props.createdUser) {
      data = {
        ...processorData,
        token: this.props.token,
      };

      if (anchorShortUrl || processorData.productType === 'MEMBERSHIP') {
        data.siteSubcat = generateSiteSubcat(
          data.originalDomain,
          anchorShortUrl
        );
      }
      this.processPurchaseRequest(
        processorId,
        priceId,
        this.props.createdUser,
        data
      );
    } else {
      this.fetchUserName(processorId, priceId).
        then((usernameRes) => {
          data = processorData;

          if (anchorShortUrl || processorData.productType === 'MEMBERSHIP') {
            data.siteSubcat = generateSiteSubcat(
              data.originalDomain,
              anchorShortUrl
            );
          }
          if (isAnchorCampaign) {
            callApi(STATUS_URL, 'get', {}, {}, {}, true, true).then((res) => {
              if (res.data.user) {
                data.email = res.data.user.account.email;
                data.token = res.data.user.token;
              }
              this.processPurchaseRequest(
                processorId,
                priceId,
                usernameRes.data.username,
                data
              );
            });
          } else {
            this.processPurchaseRequest(
              processorId,
              priceId,
              usernameRes.data.username,
              data
            );
          }
        }).
        catch((error) => {
          this.setState({ processingPayment: false });
          console.error(error);
        });

    }
  };

  isPromoPage = () =>
    ['/lifetime-promo-live', '/promo/asn-awards'].includes(window.location.pathname);


  generateProcessorData = (data) => {
    const {
      activeCampaign,
      anchorPortalCampaign,
      anchorShortUrl,
      NNLivePromoPage,
      NNPromoPage,
      hasPromoInURL,
    } = this.props;
    const { promoCodeInfo } = this.state;
    const hasAtc = getCookie('_atc');
    const promoPage = this.isPromoPage() || this.props?.isCampaignActive;
    const promoBlockedByAtc = hasAtc === PROMO_CODES.CAM4_SOURCE;
    const fanDiscountActive =
      (hasAtc === PROMO_CODES.CAM4_ANCHOR_SOURCE ||
        hasAtc === PROMO_CODES.PROMO_ANCHOR_SOURCE) &&
      anchorPortalCampaign?.anchorPortal;

    const processorData = decidePromoInfo(
      promoPage,
      activeCampaign,
      promoBlockedByAtc,
      promoCodeInfo,
      anchorPortalCampaign,
      NNLivePromoPage,
      NNPromoPage,
      fanDiscountActive,
      hasAtc,
      hasPromoInURL,
      data,
      this.queryParams.email,
    );

    return addDataForGiftAndItemProduct(processorData, anchorShortUrl);
  };

  isMembershipCheckout = (isFanclub) => {
    const { isItem, isGift } = this.props;

    return !isGift && !isItem && !isFanclub;
  }

  getFanclubProcessorData = (processorData, username) => {
    return new Promise(async (resolve, reject) => {
      try {
        const extraPayload = {};
        const isFanclub = processorData.productType === 'FANCLUB';
        const campaignIsNotActive = !processorData.affiliateCode;
        const isAsnFanzoneCampaign = processorData?.affiliateCode === 'ASN23FANZONE';

        const isEverflowCodePresent = processorData?.affiliateCode?.includes('everflow');
        if (isFanclub && (campaignIsNotActive || isEverflowCodePresent || isAsnFanzoneCampaign)) {
          const { data, error } = await getFanclubPurchaseInfo(parseInt(processorData.subCategory), username);

          if (!error) {
            extraPayload.hash = data.data.hash;
            extraPayload.amount = data.data.amount;
          }
        }
        resolve(extraPayload);
      } catch (error) {
        reject(error);
      }
    });
  };

  formatEpayReqBody = (dataObject) => {
    const {
      amount,
      orderId,
      productDetails: {
        recurringAmount,
        recurringPeriod,
        recurringPeriodUnit,
        initialPeriod,
        initialPeriodUnit,
      },
      crossSellOff,
      hash,
      userName,
    } = dataObject || {};
    return {
      amount: String(amount),
      orderId: String(orderId),
      recurringAmount: String(recurringAmount),
      recurringPeriod,
      recurringPeriodUnit,
      initialPeriod,
      initialPeriodUnit,
      hash,
      userName,
      xsellOff: String(crossSellOff),
    };
  }

  getMembershipProcessorData = (processorData) => {
    const { anchorToSubscribe, NNLivePromoPage } = this.props;
    let anchorId = anchorToSubscribe;
    if (NNLivePromoPage) {
      anchorId = 241;
    }
    return new Promise(async (resolve, reject) => {
      try {
        const { activeProgram } = this.state;
        let extraPayload = {};

        const { data, error } = await getPurchaseInfo(activeProgram?.id, anchorId, processorData);
        if (!error) {
          extraPayload = this.formatEpayReqBody(data)
        }

        resolve(extraPayload);
      } catch (error) {
        reject(error);
      }
    });
  };


  processPurchaseRequest = async (processorId, priceId, username, processorData) => {
    const data = this.generateProcessorData(processorData);
    const isFanclub = processorData.productType === 'FANCLUB';
    const isCampaignActive = data?.passThrough?.affiliateCode?.length;
    let extraPayload = {};

    if (isFanclub) {
      extraPayload = await this.getMembershipProcessorData(data);
      delete data.passThrough;
      delete data.username;
      delete data.token;
    };
    delete data.isAtc;
    const userName = extraPayload?.userName || username;
    getPaymentProcessor(processorId, priceId, userName, data, extraPayload).
      then((processorRes) => {
        if (data.productType !== 'ITEM') {
          this.setState({
            processingPayment: false,
            purchaseId: processorRes?.data?.nextStage?.parameters?.purchaseId,
            submitButtonDisabled: false,
          });
        }
        this.sendToProcessor(processorRes.data);
      }).
      catch((error) => {
        const errorCode = 400;
        console.error(error);
        PaymentStore.changeProcessorForUser(this.props.user, processorId);
        NotificationStore.error('There was a problem with payment. Please try again.');
        PayPerViewStore.setPaymentLoading(false);

        if (error?.response?.status === errorCode) {
          this.setState({
            processingPayment: false,
            submitButtonDisabled: false,
          });
          this.addError(getPurchaseError(error.response.data.reason));
        }
        if (this.props.isItem) {
          PayPerViewStore.setPaymentLoading(false);
          PayPerViewStore.setStatusMessage(
            'There was a problem with payment. Please try again.'
          );
          PayPerViewStore.setShowPayPerViewModal(true);
        }
        if (this.props.isGift) {
          console.error('Could not get payment processor', error);
          this.props.closeTipping();
        }
      });
  };

  getBillingAddress = () => {
    const { country, zip } = this.state;

    return {
      country,
      zip,
    };
  };

  getThreeDS = () => {
    const { activeProgram } = this.state;

    return {
      amount: activeProgram.amount * 100,
      currency: activeProgram.currency.name,
      accountId: 1001295220,
    };
  };

  getProcessorId = async () => {
    const { user } = this.props;
    if (!user?.authenticated) {
      return PaymentStore.processorToUse;
    }

    const data = await PaymentStore.getProcessorForUser(user);

    if (user?.authenticated &&
      data?.data?.useAlternativePaymentProcessor) {
      return PROCESSOR_IDS.EPOCH;
    }

    return PROCESSOR_IDS.SEGPAY;
  };

  clearErrors = () => {
    this.setState({ errors: [] });
  };

  addError = (errorMessage) => {
    this.setState((state) => {
      return { errors: [...state.errors, errorMessage] };
    });
  };

  getPaysafeInitErrorMessage = (error) => {
    switch (error.code) {
      case '9044':
        return 'Invalid field: country code';
      case '9045':
        return 'Invalid field: ZIP code';
      case '9003':
        return error.displayMessage;
      default:
        return null;
    }
  };

  handleFormFieldChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleCountryChange = (e) => {
    this.setState({ country: e.target.value });
  };

  getFanclubAmount = (amount, recurringAmount, max, fee) => {
    if (amount && !max) {
      const decimalPoint = 10000;

      const convertedAmount = amount * decimalPoint;
      const convertedFee = fee * decimalPoint;

      const finalAmount = parseInt(convertedAmount - convertedFee, 10);

      return finalAmount / decimalPoint;
    }

    return recurringAmount || amount;
  };

  calculateRecurringAmmount = (program) => {
    const { isMrSkinPromoPage, anchorToSubscribe } = this.props;
    const { details, amount } = program || {};
    const FEE = details.fee || 0;
    const monthlyAmount = (amount - FEE) / details.recurringPeriod || (details.recurringAmount && parseInt(details.recurringAmount, 10));

    const FANCLUB_AMOUNT = this.getFanclubAmount(amount, details.recurringAmount, details?.max, FEE);
    // round to 2 decimals if not a whole number
    const monthlyAmountToShow =
      (monthlyAmount % 1 !== 0) ? monthlyAmount?.toFixed(2) : monthlyAmount;

    if (program.details && program.details.lifetime && !isMrSkinPromoPage) {
      return (
        <>
          <span className="monthly-fee">Under $1</span>
          <sub className="recurring-period">
            <small className="caps">{'/month'}</small>
          </sub>
        </>
      );
    }

    if (isMrSkinPromoPage && details && details.lifetime) {
      return (
        <>
          <span className="monthly-fee">
            <span className="currency">{program.currency.symbol}</span>
            {amount - FEE}
          </span>
        </>
      );
    }

    return amount < 1 && !details.isDynamicPrice ? (
      'FREE'
    ) : (
      <>
        <span className="monthly-fee default">
          <span className="currency">{program.currency.symbol}</span>
          {anchorToSubscribe ? FANCLUB_AMOUNT?.toFixed(2) : monthlyAmountToShow}
        </span>
        <sub className="recurring-period">
          <small className="caps">{`/${details.recurringPeriodType}`}</small>
        </sub>
      </>
    );
  };

  getRecurringPeriod = (program) => {
    if (parseInt(program?.details?.recurringPeriod, 10) === 12 && program?.details?.recurringPeriodType?.toLowerCase() === 'month') {
      return 'YEARLY';
    }

    if (program?.details?.recurringPeriod && program?.details?.recurringPeriodType) {
      return `${program?.details?.recurringPeriodType &&
        capitalize(program.details.recurringPeriodType)}LY`;
    }

    return undefined;
  }

  displayTimeUnit = (program) => {
    const { isMrSkinPromoPage } = this.props;
    const { details: { trialPeriod, trialUnit, isTrial } } = program;
    const recurringPeriodString = this.getRecurringPeriod(program);


    if (isTrial) {
      const trialUnitSingle = capitalize(
        trialUnit.substring(0, trialUnit.length - 1)
      );

      return (
        <span className="time-unit">
          {trialPeriod}-
          {isTrial ? capitalize(trialUnit) : trialUnitSingle} Trial
        </span>
      );
    }
    let lifeTimeProduct =
      program.details && program.details.lifetime ? 'LIFETIME' : '';
    if (isMrSkinPromoPage) {
      lifeTimeProduct = 'Lifetime membership';
    }

    return (
      <span
        className={`time-unit ${isMrSkinPromoPage ? 'time-unit-smaller' : ''}`}
      >
        {recurringPeriodString || lifeTimeProduct}
      </span>
    );

  };

  shouldRenderPromoCheckoutBanner = (promoPage) => {
    const { user, isMrSkinPromoPage } = this.props;
    const hasAtc = getCookie('_atc');
    const userPremiumExpired = user.authenticated && !user.user.activeSubscription;
    const isGuest = user && !user.authenticated;
    const userIsNotSubscribed = isGuest || userPremiumExpired;
    const promoBlockedByAtc = hasAtc && hasAtc === PROMO_CODES.CAM4_SOURCE;

    if (userIsNotSubscribed && !promoBlockedByAtc && isMrSkinPromoPage) {
      return true;
    }

    return false;
  };

  getFormToDisplay = () => {
    const {
      anchorToSubscribe,
      anchorShortUrl,
      anchorSubscriptionPrograms,
      isMembershipPaymentPage,
      activeCampaign,
      isGift,
      isItem,
      title,
      anchorName,
      price,
      closeModal,
      listOfActiveCampaigns,
      programs,
      showPromoInput,
      feeIsAdded,
      hasPromoInURL,
      fanzoneCampaign,
      isMrSkinPromoPage,
    } = this.props;

    const {
      activeProgram,
      selectedPaymentMethod,
      paysafeAvailable,
      epochAvailable,
      oneClickPaymentData,
      submitButtonDisabled,
      shouldAnimate,
      promoCodeInfo,
      oldPrices,
    } = this.state;

    const ASNCampaign = window.location.pathname === '/promo/asn-awards';
    const promoPage = this.isPromoPage();
    const isErrorMessage = PayPerViewStore.statusMessage.length !== 0;
    const shouldShowPromoCheckoutBanner = this.shouldRenderPromoCheckoutBanner(promoPage);

    return (
      <React.Fragment>
        <ClipStoreItemPurchaseContent
          anchorName={anchorName}
          closeModal={closeModal}
          isErrorMessage={isErrorMessage}
          isItem={isItem}
          price={price}
          title={title}
          onBuyPayPerViewClip={this.onBuyPayPerViewClip}
        />
        <TippingModalContent
          activeProgram={activeProgram}
          epochAvailable={epochAvailable}
          handlePackageChange={this.handlePackageChange}
          isGift={isGift}
          oneClickPaymentData={oneClickPaymentData}
          paysafeAvailable={paysafeAvailable}
          programs={programs}
          renderFeeMessage={feeIsAdded}
          selectedPaymentMethod={selectedPaymentMethod}
          submitButtonDisabled={submitButtonDisabled}
          onPaymentMethodChange={this.onPaymentMethodChange}
          onSubmitClick={this.onSubmitClick}
        />
        <FanzoneSubscriptionForm
          activeCampaign={activeCampaign}
          activeProgram={activeProgram}
          anchorShortUrl={anchorShortUrl}
          fanzoneCampaign={fanzoneCampaign}
          anchorSubscriptionPrograms={anchorSubscriptionPrograms}
          anchorToSubscribe={anchorToSubscribe}
          calculateRecurringAmmount={this.calculateRecurringAmmount}
          displayTimeUnit={this.displayTimeUnit}
          epochAvailable={epochAvailable}
          fetchPackages={this.props.fetchPackages}
          handlePackageChange={this.handlePackageChange}
          hasPromoInURL={hasPromoInURL}
          isFanzoneSubscriptionPage={true}
          isGift={isGift}
          isItem={isItem}
          isPromoPage={promoPage}
          listOfActiveCampaigns={listOfActiveCampaigns}
          oldPrices={oldPrices}
          oneClickPaymentData={oneClickPaymentData}
          paysafeAvailable={paysafeAvailable}
          promoCodeInfo={promoCodeInfo}
          renderFeeMessage={feeIsAdded}
          selectedPaymentMethod={selectedPaymentMethod}
          setAnimationState={this.setAnimationState}
          setPromoCodeInfo={this.setPromoCodeInfo}
          shouldAnimate={shouldAnimate}
          shouldShowPromoCheckoutBanner={shouldShowPromoCheckoutBanner}
          showPromoInput={showPromoInput}
          onPaymentMethodChange={this.onPaymentMethodChange}
          onSubmitClick={this.onSubmitClick}
        />
        <MembershipForm
          ASNCampaign={ASNCampaign}
          activeCampaign={activeCampaign}
          isMembershipPaymentPage={isMembershipPaymentPage}
          activeProgram={activeProgram}
          fanzoneCampaign={fanzoneCampaign}
          anchorToSubscribe={anchorToSubscribe}
          calculateRecurringAmmount={this.calculateRecurringAmmount}
          displayTimeUnit={this.displayTimeUnit}
          epochAvailable={epochAvailable}
          fetchPackages={this.props.fetchPackages}
          handlePackageChange={this.handlePackageChange}
          hasPromoInURL={hasPromoInURL}
          isFanzoneSubscriptionPage={false}
          isGift={isGift}
          isItem={isItem}
          isPromoPage={promoPage}
          isCampaignActive={this.props.isCampaignActive}
          listOfActiveCampaigns={listOfActiveCampaigns}
          mrSkinCampaign={isMrSkinPromoPage}
          oldPrices={oldPrices}
          oneClickPaymentData={oneClickPaymentData}
          paysafeAvailable={paysafeAvailable}
          programs={programs}
          promoCodeInfo={promoCodeInfo}
          renderFeeMessage={feeIsAdded}
          selectedPaymentMethod={selectedPaymentMethod}
          setAnimationState={this.setAnimationState}
          setPromoCodeInfo={this.setPromoCodeInfo}
          shouldAnimate={shouldAnimate}
          shouldShowPromoCheckoutBanner={shouldShowPromoCheckoutBanner}
          showPromoInput={showPromoInput}
          onPaymentMethodChange={this.onPaymentMethodChange}
          onSubmitClick={this.onSubmitClick}
        />
      </React.Fragment>
    );
  };

  onPaymentMethodChange = (e) => {
    this.setState({ selectedPaymentMethod: e.target.value });
  };

  onBuyPayPerViewClip = async () => {
    const {
      type,
      clipId,
      anchorShortUrl,
      user,
    } = this.props;
    const { activeProgram } = this.state;
    const processorId = await this.getProcessorId();

    const userName = sessionStorage.getItem('username') || user.user.username;
    const token = sessionStorage.getItem('token') || user.user.token;
    const originalDomain = this.decideOriginalDomain();

    PayPerViewStore.setStatusMessage('');
    PayPerViewStore.setPaymentLoading(true);
    PayPerViewStore.setShowPayPerViewModal(false);

    const url =
      type === 'GALLERY' ? CLIPSTORE_GALLERY_PAY_INFO : CLIPSTORE_VIDEO_PAY_INFO;

    const payInfoUrl = url.
      replace('{id}', encodeURIComponent(PayPerViewStore.currentlySelectedAnchorID)).
      replace('{clipId}', encodeURIComponent(clipId));

    callApi(payInfoUrl, 'get', {}, {}, {}, true, true, true).
      then((res) => {
        const postData = {
          originalDomain,
          returnPath: this.getReturnPath(),
          paymentType: this.getPaymentType(),
          token,
          productType: 'ITEM',
          subCategory: String(res.data.subCategory),
          hash: res.data.hash,
          orderId: res.data.orderId,
          amount: res.data.amount,
          desc: res.data.desc,
          siteSubcat: generateSiteSubcat(
            originalDomain,
            (anchorShortUrl || buildAnchorLink({
              id: PayPerViewStore.currentlySelectedAnchorID,
              name: PayPerViewStore.currentlySelectedAnchor,
            }))
          ),
          email: res.data.email,
        };

        if (!userName || userName === 'null' || !token) {
          PayPerViewStore.setPaymentLoading(false);
          PayPerViewStore.setShowPayPerViewModal(true);
          PayPerViewStore.setStatusMessage(
            'There was a problem with payment. Please try again.'
          );
          console.error(
            'Account Packages: username or token is null',
            userName
          );

          return;
        }

        this.processPurchaseRequest(
          processorId,
          activeProgram.id,
          userName,
          postData
        );
      }).
      catch(() => {
        PayPerViewStore.setPaymentLoading(false);
        PayPerViewStore.setShowPayPerViewModal(true);
        PayPerViewStore.setStatusMessage(
          'There was an issue with payment, please try again later.'
        );
      });
  };

  onResetPaysafeForm = () => {
    this.setState((state) => {
      return {
        ...state,
        holderName: '',
        country: '',
        zip: '',
        email: '',
        errors: [],
      };
    });
  };

  onPaysafeSubmit = (instance, xSellsState) => {
    const { activeProgram, holderName } = this.state;
    const processorId = this.getProcessorId();
    const billingAddress = this.getBillingAddress();

    const paysafeData = { vault: { holderName, billingAddress } };
    instance.tokenize(paysafeData, (newInstance, error, result) => {
      if (error) {
        this.setPurchaseButtonDisabled(false);
        const errorMessage = this.getPaysafeInitErrorMessage(error);
        this.setState((state) => {
          return { errors: [...state.errors, errorMessage] };
        });
      } else {
        this.handlePurchaseForm(
          activeProgram,
          processorId,
          result.token,
          xSellsState
        );
      }
    });
  };

  onSubmitClick = async (e) => {
    this.setState({ submitButtonDisabled: true });
    if (e) {
      e.preventDefault();
    }
    const { activeProgram, oneClickPaymentData } = this.state;
    const { isGift, setTipIsLoading } = this.props;
    if (isGift) {
      setTipIsLoading(true);
    }
    const processorId = await this.getProcessorId();
    switch (processorId) {
      case PROCESSOR_IDS.EPOCH:
        this.handlePurchaseForm(activeProgram, processorId);
        break;
      case PROCESSOR_IDS.PAYSAFE:
        if (oneClickPaymentData) {
          this.handlePurchaseForm(activeProgram, processorId);
        } else {
          this.openPaysafeModal();
        }
        break;
      default:
        this.handlePurchaseForm(activeProgram, processorId);
        break;
    }
  };

  componentWillUnmount() {
    PayPerViewStore.setShowPayPerViewModal(false);
  }

  render() {
    const {
      user,
      anchorToSubscribe,
    } = this.props;
    const {
      activeProgram,
      showPaysafeModal,
      holderName,
      email,
      country,
      zip,
      errors,
      processingPayment,
      disablePurchaseButton,
    } = this.state;
    const userPremiumExpired =
      user.authenticated && !user.user.activeSubscription;
    const isGuest = user && !user.authenticated;

    return (
      <div
        className={classnames({
          'content': true,
          'giftingModal': this.props.isGift,
          'package-invisible': this.props.isInvisible,
        })}
        id="join_body"
      >
        <div
          className={'package-selection-container'}
        >
          {this.getFormToDisplay()}
        </div>
        <Modal
          closeOnOuterClick={false}
          containerStyle={{
            width: '100%',
            padding: '0',
            marginTop: '100px',
            background: 'transparent',
          }}
          show={showPaysafeModal}
        >
          <PaysafeForm
            activeProgram={activeProgram}
            addError={this.addError}
            anchorToSubscribe={anchorToSubscribe}
            clearErrors={this.clearErrors}
            close={this.closePaysafeModal}
            country={country}
            createdUser={this.props.createdUser}
            disablePurchaseButton={disablePurchaseButton}
            email={email}
            errors={errors}
            handleCountryChange={this.handleCountryChange}
            handleFieldChange={this.handleFormFieldChange}
            holderName={holderName}
            isGift={this.props.isGift}
            isGuest={isGuest}
            processing={processingPayment}
            setPurchaseButtonDisabled={this.setPurchaseButtonDisabled}
            userPremiumExpired={userPremiumExpired}
            zip={zip}
            onDismount={this.onResetPaysafeForm}
            onSubmit={this.onPaysafeSubmit}
          />
        </Modal>
        {this.state.showOverlay && (
          <div className="payment-overlay">
            <div className="lds-dual-ring" />
            <div>Processing...</div>
          </div>
        )}
      </div>
    );
  }
}

export default AccountPackages;

AccountPackages.defaultProps = { isMrSkinPromoPage: false };
